import { Button, Modal, Result } from 'antd'
import { ExceptionStatusType, ResultStatusType } from 'antd/lib/result'
import { t } from 'i18next'
import { useEffect, useState } from 'react'
import { FallbackProps } from 'react-error-boundary'

type ContentErrorModalProps = {
    error: Error
    handleClose: () => void
}

type ErrorContent = {
    message: string
    cloudwatch_link: string
    status: number
}

const ContentErrorModal = ({ error, handleClose }: ContentErrorModalProps) => {
    const [errorLogged, setError] = useState({
        message: '',
        cloudwatch_link: '',
        status: 0,
    })

    useEffect(() => {
        async function getErrorLogged() {
            let errorPayload: ErrorContent = {
                message: '',
                cloudwatch_link: '',
                status: 0,
            }
            errorPayload = JSON.parse(error.message)
            setError(errorPayload)
        }
        if (!errorLogged.cloudwatch_link) {
            getErrorLogged()
        }
    }, [error, errorLogged.cloudwatch_link])

    const getStatus = (): ResultStatusType => {
        const handledErrorCodes = [403, 404, 500]
        if (handledErrorCodes.includes(errorLogged.status)) {
            return errorLogged.status as ExceptionStatusType
        } else {
            return 'error'
        }
    }

    return (
        <>
            <Result
                status={getStatus()}
                title={t('common:text.error_occurred')}
                subTitle={t('common:text.try_again_later')}
                extra={[
                    <Button key="goback" type="primary" onClick={handleClose} style={{ backgroundColor: '#252535' }}>
                        {t('common:cta.go_back')}
                    </Button>,
                    <Button
                        key="refresh"
                        type="primary"
                        onClick={() => window.location.reload()}
                    >
                        {t('common:cta.refresh')}
                    </Button>,
                ]}
            />
        </>
    )
}

export const ErrorFallbackModal = ({
    error,
    resetErrorBoundary,
}: FallbackProps): JSX.Element => {
    const [isModalVisible, setIsModalVisible] = useState(true)
    const handleClose = () => {
        resetErrorBoundary()
        setIsModalVisible(false)
        window.history.back()
    }
    return (
        <Modal
            open={isModalVisible}
            closable={true}
            maskClosable={true}
            onOk={handleClose}
            footer={null}
            destroyOnClose={true}
        >
            <ContentErrorModal error={error} handleClose={handleClose} />
        </Modal>
    )
}
